import { render, staticRenderFns } from "./bookingTypesPage.vue?vue&type=template&id=15523f24&scoped=true&"
import script from "./bookingTypesPage.vue?vue&type=script&lang=ts&"
export * from "./bookingTypesPage.vue?vue&type=script&lang=ts&"
import style0 from "./bookingTypesPage.vue?vue&type=style&index=0&id=15523f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15523f24",
  null
  
)

export default component.exports